"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dailySummaryHopperTypes = void 0;
exports.dailySummaryHopperTypes = {
    SET_LOADING: 'DAILY SUMMARY HOPPER TYPES SET LOADING',
    SET_ERROR: 'DAILY SUMMARY HOPPER TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'DAILY SUMMARY HOPPER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'DAILY SUMMARY HOPPER TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'DAILY SUMMARY HOPPER TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE: 'DAILY SUMMARY HOPPER TYPES ON FILTER CHANGE',
    ON_ENTER_EDIT_CLICK: 'DAILY SUMMARY HOPPER TYPES ON ENTER EDIT',
    ON_SUMMARY_MODE_CLICK: 'DAILY SUMMARY HOPPER TYPES ON SUMMARY MODE CLICK',
};
